// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"38":"79c7c6ec","52":"ac16a047","322":"5608ae22","963":"4360c33e","972":"0be747ec"}[chunkId] + ".chunk.css");